import React, { useState } from 'react';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { FieldCheckbox, IconSearch } from '../../../components';
import css from './SelectMultipleFilter.module.css';

function RenderBrand(props) {
  const intl = useIntl();
  const { options, id, name, containerClass } = props;

  // 1. Core Logic: Manage only UI state (Search & Visibility) locally.
  // Selection state is handled by React Final Form via the 'name' prop.
  const [searchInput, setSearchInput] = useState('');
  const [visibleCount, setVisibleCount] = useState(20);

  const handleSearchChange = e => {
    setSearchInput(e.target.value);
    // Reset visibility when searching to show relevant results immediately
    setVisibleCount(20);
  };

  // 2. Filter Options based on search
  const filteredOptions = searchInput
    ? options.filter(optionConfig =>
        optionConfig.label.toLowerCase().includes(searchInput.toLowerCase())
      )
    : options;

  // 3. Slice for "Show More" functionality
  const displayedOptions = filteredOptions.slice(0, visibleCount);

  const handleShowMore = e => {
    e.preventDefault(); // Prevent form submission
    setVisibleCount(prevCount => prevCount + 20);
  };

  const handleShowLess = e => {
    e.preventDefault(); // Prevent form submission
    setVisibleCount(20);
  };

  return (
    <fieldset className={containerClass}>
      <div className={css.searchBlock}>
        <IconSearch />
        <input
          type="text"
          placeholder={intl.formatMessage({ id: 'RenderBrand.searchPlaceholder' })}
          value={searchInput}
          onChange={handleSearchChange}
          className={css.searchInput}
        />
      </div>

      <ul className={css.list}>
        {displayedOptions.map(optionConfig => {
          const { option, label } = optionConfig;
          const fieldId = `${id}.${option}`;

          return (
            <li key={fieldId} className={css.item}>
              <FieldCheckbox
                id={fieldId}
                name={name} // RFF uses this to group values (e.g. ['nike', 'adidas'])
                label={label}
                value={option} // The value pushed to the array when checked
              />
            </li>
          );
        })}
      </ul>

      <div className={css.showMoreLessBtns}>
        {filteredOptions.length > visibleCount && (
          <button type="button" onClick={handleShowMore} className={css.showMoreButton}>
            <FormattedMessage id="RenderBrand.showMore" />
          </button>
        )}

        {/* Only show 'Show Less' if we are showing more than initial AND not currently searching */}
        {visibleCount > 20 && (
          <button type="button" onClick={handleShowLess} className={css.showLessButton}>
            <FormattedMessage id="RenderBrand.showLess" />
          </button>
        )}
      </div>
    </fieldset>
  );
}

export default RenderBrand;
